import { useSelector } from "react-redux";
import { CreateCountry } from "../../../store/country-store/country-actions"; 
import CountryForms from "../../../components/Forms/CountryForms";
import { GetCountries } from "../../../store/country-store/country-actions";
import { getTokenInfo } from "../../../utils/Guard";

const CountryCreate = () => {
  const country = useSelector((state) => state.country.country);
  


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <CountryForms actionCountry={CreateCountry} country={country} />
    </div>
    </>
  );
};
export default CountryCreate;
